import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Style.css";
import { useConfig } from "../../ConfigContext";
import { buildLegalLinks } from "../Legal/legalLinks";
import LegalLink from "../Legal/LegalLink";

// `key` is the CMS field (config.<key>, set in Admin > App Info); `href` is
// only the fallback used when that field is empty.
const PLATFORMS = [
  { src: "/RokuLogo.png", alt: "Roku", key: "roku_app_url", href: "https://channelstore.roku.com/details/a48dcb78afc6cc360fd0937d9ba5c358:65ffd8fc201292e3c00413160edd70e0/vh2-television" },
  { src: "/GooglePlayStore.png", alt: "Google Play", key: "android_app_url", href: "https://play.google.com/store/apps/details?id=com.app.VH2Networks" },
  { src: "/AppleStore.png", alt: "App Store", key: "ios_app_url" },
  { src: "/Samsung.png", alt: "Samsung", key: "samsung_tv_app_url" },
  { src: "/LG.png", alt: "LG", key: "lg_tv_app_url" },
  { src: "/FireTv.png", alt: "Fire TV", key: "firetv_app_url", href: "https://www.amazon.com/gp/product/B0H7R3Q78X" },
];

const Footer = () => {
  const location = useLocation();
  const siteTitle = process.env.REACT_APP_SITE_TITLE;
  const contactEmail = process.env.REACT_APP_CONTACT_EMAIL;

  const config = useConfig();
  // From the CMS (config.legal_links); env vars only as a fallback.
  const legalLinks = buildLegalLinks(config);
  const platforms = PLATFORMS.map((p) => ({ ...p, href: config?.[p.key] || p.href }));

  return (
    <footer className="ott-footer">
      <div className="ott-footer__inner">

        {/* ── Top: brand + link columns ── */}
        <div className="ott-footer__top">

          {/* Brand */}
          <div className="ott-footer__brand">
            <img
              src={`/${process.env.REACT_APP_APP_LOGO}`}
              alt={siteTitle}
              className="ott-footer__logo"
            />
            <p className="ott-footer__tagline">
              Stream movies, series &amp; live TV — anytime, on any screen.
            </p>
          </div>

          {/* Help */}
          <div className="ott-footer__col">
            <h4 className="ott-footer__heading">Help</h4>
            <Link className="ott-footer__link" to="/help-center">
              Help Center &amp; FAQ
            </Link>
            {/* Tell the form which page the viewer was on. */}
            <Link
              className="ott-footer__link"
              to="/support"
              state={location.pathname === "/support" ? undefined : { from: location.pathname }}
            >
              Contact Support
            </Link>
            <Link className="ott-footer__link" to="/Contact-Us">
              Contact Us
            </Link>
          </div>

          {/* Legal */}
          {legalLinks.length > 0 && (
            <div className="ott-footer__col">
              <h4 className="ott-footer__heading">Legal</h4>
              {legalLinks.map((l) => (
                <LegalLink key={l.type} link={l} className="ott-footer__link" />
              ))}
            </div>
          )}

          {/* Platforms */}
          <div className="ott-footer__col ott-footer__col--platforms">
            <h4 className="ott-footer__heading">Available on</h4>
            <div className="ott-footer__platforms">
              {platforms.map((p) =>
                p.href ? (
                  <a
                    className="ott-footer__platform"
                    key={p.alt}
                    title={p.alt}
                    href={p.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={p.src} alt={p.alt} loading="lazy" />
                  </a>
                ) : (
                  <span className="ott-footer__platform" key={p.alt} title={p.alt}>
                    <img src={p.src} alt={p.alt} loading="lazy" />
                  </span>
                )
              )}
            </div>
          </div>
        </div>

        {/* ── Contact + Bottom bar ── */}
        <div className="footer-contact">
          Contact Us -{" "}
          <a className="ott-footer__link" href={`mailto:${contactEmail}`}>
            {contactEmail}
          </a>
        </div>

        <div className="ott-footer__bottom">
          <span className="ott-footer__copy">
            © {new Date().getFullYear()} {siteTitle}. All rights reserved.
          </span>
          <span className="ott-footer__made">Crafted for cinematic streaming.</span>
        </div>

      </div>
    </footer>
  );
};

export default Footer;